import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Spin,
    message,
    App,
    Select,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { ADD_EMAIL, LIST_COURSE } from "../../apis/apis";
import { useNavigate } from "react-router-dom";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import HtmlEditorWithPreview from "../../components/HtmlEditorWithPreview";

export default function AddEmail() {
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [name, set_name] = useState("");
    const [envelope_sender, set_envelope_sender] = useState("");
    const [subject, set_subject] = useState("");
    const [course_id, set_course_id] = useState("");
    const [course_List, set_course_List] = useState([]);
    const [templates_images, set_templates_images] = useState("");
    const [message_value, set_message_value] = useState("");
    const [errors, set_errors] = useState("");
    const [spamModalVisible, setSpamModalVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(timer);
    }, []);

    const onFinish = async () => {
        setLoading(true);
        setSpamModalVisible(true); // Show Modal

        const FORM_DATA = new FormData();
        FORM_DATA.append("name", name);
        FORM_DATA.append("envelope_sender", envelope_sender);
        FORM_DATA.append("subject", subject);
        FORM_DATA.append("course_id", course_id);
        FORM_DATA.append("html_type", 1);
        FORM_DATA.append("templates_images", templates_images);
        FORM_DATA.append("message_value", message_value);

        try {
            const response = await ADD_EMAIL(FORM_DATA);

            if (response?.data?.status) {
                notification.success({
                    message: "Successful",
                    description: response?.data?.message,
                });
                setSpamModalVisible(false); // Hide Modal
                navigate("/email-template");
            } else {
                setLoading(false);
                setSpamModalVisible(false);
                set_errors(response?.data?.errors);
            }
        } catch (error) {
            setSpamModalVisible(false);
            message.error(
                "Server Error: " + (error?.response?.data?.message || "Unknown error")
            );
        }
    };

    const extractNameOnly = (value) => {
        return value.replace(/[<>@.]/g, "");
    };

    const COURSE_LIST_API = async () => {
        const API_CALL = await LIST_COURSE(new FormData());
        if (API_CALL?.data?.status) {
            set_course_List(API_CALL.data.data.map(item => ({
                label: item.title,
                value: item.id
            })));
        }
    };
    useEffect(() => {
        COURSE_LIST_API();
    }, []);

    const handleSearchCourse = async (searchText) => {

        try {
            const formData = new FormData();
            formData.append("title", searchText);
            const response = await LIST_COURSE(formData);
            if (response?.data?.status) {
                const options = response.data.data.map((item) => ({
                    label: item.title,
                    value: item.id,
                }));
                set_course_List(options);
            } else {
                set_course_List([]);
            }
        } catch (error) {
            console.error("Error searching Course list:", error);
            set_course_List([]);
        } finally {

        }
    };

    return (
        <div className="lms-body">
            <Card>
                <div className="lms-form">
                    <Row>
                        <Col span={24}>
                            <h2>
                                <span
                                    style={{ cursor: "pointer", marginRight: "5px" }}
                                    onClick={() => navigate("/email-template")}
                                >
                                    <LeftOutlined />
                                </span>
                                ADD Email Template
                            </h2>
                            {errors?.smtp_error && (
                                <span style={{ color: "red" }}>{errors?.smtp_error}</span>
                            )}
                        </Col>
                    </Row>

                    {loading ? (
                        <CulsightPageLoader />
                    ) : (
                        <Form
                            form={form}
                            layout="vertical"
                            autoComplete="off"
                            onFinish={onFinish}
                            validateTrigger="onSubmit"
                        >
                            <Form.Item
                                label="Name"
                                name="name"
                                validateTrigger="onChange"
                                rules={[
                                    { min: 2, message: "Name must be at least 2 characters" },
                                    { max: 50, message: "Name cannot exceed 50 characters" },
                                    {
                                        pattern: /^[A-Za-z-0-9_. ]+$/,
                                        message: "Special characters are not allowed",
                                    },
                                ]}
                            >
                                <Input
                                    value={name}
                                    showCount
                                    placeholder="Enter name"
                                    onChange={(e) => set_name(e.target.value)}
                                />
                                {errors?.name && (
                                    <span style={{ color: "red" }}>{errors?.name}</span>
                                )}
                            </Form.Item>

                            <Form.Item label="Envelope Sender">
                                <Input
                                    value={envelope_sender}
                                    placeholder="Enter envelope sender"
                                    onChange={(e) =>
                                        set_envelope_sender(extractNameOnly(e.target.value))
                                    }
                                />
                                {errors?.envelope_sender && (
                                    <span style={{ color: "red" }}>{errors?.envelope_sender}</span>
                                )}
                            </Form.Item>

                            <Form.Item label="Subject">
                                <Input
                                    placeholder="Enter subject"
                                    value={subject}
                                    onChange={(e) => set_subject(e.target.value)}
                                />
                                {errors?.subject && (
                                    <span style={{ color: "red" }}>{errors?.subject}</span>
                                )}
                            </Form.Item>
                            <Form.Item label="Images (Comma separated urls)">
                                <Input
                                    placeholder="Images"
                                    value={templates_images}
                                    onChange={(e) => set_templates_images(e.target.value)}
                                />
                                {errors?.subject && (
                                    <span style={{ color: "red" }}>{errors?.subject}</span>
                                )}
                            </Form.Item>

                            {course_List.length > 0 && <>
                                <Form.Item label="Select Course">
                                    <Select
                                        showSearch
                                        size="large"
                                        placeholder="Select Course"
                                        value={course_id}
                                        onChange={(value) => set_course_id(value)}
                                        onSearch={handleSearchCourse}
                                        filterOption={false}
                                        notFoundContent={loading ? <Spin size="small" /> : null}
                                        options={course_List}
                                    />
                                </Form.Item>
                            </>}

                            <HtmlEditorWithPreview
                                setHtmlCode={set_message_value}
                                description="Message"
                                htmlCode={message_value}
                            />

                            <Form.Item>
                                <Button
                                    type="primary"
                                    style={{ float: "right" }}
                                    htmlType="submit"
                                >
                                    Save
                                </Button>
                            </Form.Item>
                        </Form>
                    )}
                </div>
            </Card>

            <Modal
                open={spamModalVisible}
                title="Checking for Spam..."
                footer={null}
                closable={false}
                centered
            >
                <p>Please wait while we check for spam...</p>
                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <Spin size="large" />
                </div>
            </Modal>
        </div>
    );
}
